
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton } from '@/components';
import { useAccountDetail } from '@/modules/account/app/model/detail';
import { formatDate, toDuration } from '@/common/utils/helpers';
import { ActivityFilterType, TransactionType } from '@/modules/account/app/model/mixins';
import { useAccountActions, useAccountAppMixins } from '@/modules/account/app/model/mixins';
import { ROUTE_NAME_MESSAGE } from '@/modules/message/router';
import { ROUTE_NAME_ACCOUNT } from '@/modules/account/router';

export default defineComponent({
    name: ROUTE_NAME_ACCOUNT.APP.DETAIL,
    components: { AppCard, AppButton },
    setup() {
        const { model, fetch } = useAccountDetail();
        const { routerLink } = useAccountAppMixins();
        const actions = useAccountActions(fetch);

        onMounted(async () => {
            await fetch();
        });

        return {
            model,
            actions,
            formatDate,
            toDuration,
            TransactionType,
            ActivityFilterType,
            ROUTE_NAME_ACCOUNT,
            ROUTE_NAME_MESSAGE,
            routerLink
        };
    }
});
